import { QUERIES } from "../../utils/mediaQuery";
export let SIZES = /*#__PURE__*/function (SIZES) {
  SIZES["NONE"] = "none";
  SIZES["FIFTY"] = "50";
  SIZES["ONE_HUNDRED"] = "100";
  SIZES["ONE_HUNDRED_FIFTY"] = "150";
  SIZES["TWO_HUNDRED"] = "200";
  SIZES["THREE_HUNDRED"] = "300";
  SIZES["FOUR_HUNDRED"] = "400";
  SIZES["FIVE_HUNDRED"] = "500";
  SIZES["SIX_HUNDRED"] = "600";
  SIZES["EIGHT_HUNDRED"] = "800";
  SIZES["ONE_THOUSAND"] = "1000";
  SIZES["ONE_THOUSAND_TWO_HUNDRED"] = "1200";
  SIZES["ONE_THOUSAND_SIX_HUNDRED"] = "1600";
  return SIZES;
}({});
export const paddingClasses = {
  [SIZES.NONE]: "p-0",
  [SIZES.FIFTY]: "p-50",
  [SIZES.ONE_HUNDRED]: "p-100",
  [SIZES.ONE_HUNDRED_FIFTY]: "p-150",
  [SIZES.TWO_HUNDRED]: "p-200",
  [SIZES.THREE_HUNDRED]: "p-300",
  [SIZES.FOUR_HUNDRED]: "p-400",
  [SIZES.FIVE_HUNDRED]: "p-500",
  [SIZES.SIX_HUNDRED]: "p-600",
  [SIZES.EIGHT_HUNDRED]: "p-800",
  [SIZES.ONE_THOUSAND]: "p-1000",
  [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "p-1200",
  [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "p-1600",
  [QUERIES.LARGEDESKTOP]: {
    [SIZES.NONE]: "ld:p-0",
    [SIZES.FIFTY]: "ld:p-50",
    [SIZES.ONE_HUNDRED]: "ld:p-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "ld:p-150",
    [SIZES.TWO_HUNDRED]: "ld:p-200",
    [SIZES.THREE_HUNDRED]: "ld:p-300",
    [SIZES.FOUR_HUNDRED]: "ld:p-400",
    [SIZES.FIVE_HUNDRED]: "ld:p-500",
    [SIZES.SIX_HUNDRED]: "ld:p-600",
    [SIZES.EIGHT_HUNDRED]: "ld:p-800",
    [SIZES.ONE_THOUSAND]: "ld:p-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "ld:p-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "ld:p-1600"
  },
  [QUERIES.DESKTOP]: {
    [SIZES.NONE]: "de:p-0",
    [SIZES.FIFTY]: "de:p-50",
    [SIZES.ONE_HUNDRED]: "de:p-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "de:p-150",
    [SIZES.TWO_HUNDRED]: "de:p-200",
    [SIZES.THREE_HUNDRED]: "de:p-300",
    [SIZES.FOUR_HUNDRED]: "de:p-400",
    [SIZES.FIVE_HUNDRED]: "de:p-500",
    [SIZES.SIX_HUNDRED]: "de:p-600",
    [SIZES.EIGHT_HUNDRED]: "de:p-800",
    [SIZES.ONE_THOUSAND]: "de:p-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "de:p-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "de:p-1600"
  },
  [QUERIES.TABLET]: {
    [SIZES.NONE]: "tb:p-0",
    [SIZES.FIFTY]: "tb:p-50",
    [SIZES.ONE_HUNDRED]: "tb:p-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "tb:p-150",
    [SIZES.TWO_HUNDRED]: "tb:p-200",
    [SIZES.THREE_HUNDRED]: "tb:p-300",
    [SIZES.FOUR_HUNDRED]: "tb:p-400",
    [SIZES.FIVE_HUNDRED]: "tb:p-500",
    [SIZES.SIX_HUNDRED]: "tb:p-600",
    [SIZES.EIGHT_HUNDRED]: "tb:p-800",
    [SIZES.ONE_THOUSAND]: "tb:p-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "tb:p-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "tb:p-1600"
  },
  [QUERIES.LARGEMOBILE]: {
    [SIZES.NONE]: "lm:p-0",
    [SIZES.FIFTY]: "lm:p-50",
    [SIZES.ONE_HUNDRED]: "lm:p-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "lm:p-150",
    [SIZES.TWO_HUNDRED]: "lm:p-200",
    [SIZES.THREE_HUNDRED]: "lm:p-300",
    [SIZES.FOUR_HUNDRED]: "lm:p-400",
    [SIZES.FIVE_HUNDRED]: "lm:p-500",
    [SIZES.SIX_HUNDRED]: "lm:p-600",
    [SIZES.EIGHT_HUNDRED]: "lm:p-800",
    [SIZES.ONE_THOUSAND]: "lm:p-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "lm:p-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "lm:p-1600"
  },
  [QUERIES.MEDIUMMOBILE]: {
    [SIZES.NONE]: "mm:p-0",
    [SIZES.FIFTY]: "mm:p-50",
    [SIZES.ONE_HUNDRED]: "mm:p-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "mm:p-150",
    [SIZES.TWO_HUNDRED]: "mm:p-200",
    [SIZES.THREE_HUNDRED]: "mm:p-300",
    [SIZES.FOUR_HUNDRED]: "mm:p-400",
    [SIZES.FIVE_HUNDRED]: "mm:p-500",
    [SIZES.SIX_HUNDRED]: "mm:p-600",
    [SIZES.EIGHT_HUNDRED]: "mm:p-800",
    [SIZES.ONE_THOUSAND]: "mm:p-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mm:p-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mm:p-1600"
  }
};
export const paddingTopClasses = {
  [SIZES.NONE]: "pt-0",
  [SIZES.FIFTY]: "pt-50",
  [SIZES.ONE_HUNDRED]: "pt-100",
  [SIZES.ONE_HUNDRED_FIFTY]: "pt-150",
  [SIZES.TWO_HUNDRED]: "pt-200",
  [SIZES.THREE_HUNDRED]: "pt-300",
  [SIZES.FOUR_HUNDRED]: "pt-400",
  [SIZES.FIVE_HUNDRED]: "pt-500",
  [SIZES.SIX_HUNDRED]: "pt-600",
  [SIZES.EIGHT_HUNDRED]: "pt-800",
  [SIZES.ONE_THOUSAND]: "pt-1000",
  [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "pt-1200",
  [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "pt-1600",
  [QUERIES.LARGEDESKTOP]: {
    [SIZES.NONE]: "ld:pt-0",
    [SIZES.FIFTY]: "ld:pt-50",
    [SIZES.ONE_HUNDRED]: "ld:pt-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "ld:pt-150",
    [SIZES.TWO_HUNDRED]: "ld:pt-200",
    [SIZES.THREE_HUNDRED]: "ld:pt-300",
    [SIZES.FOUR_HUNDRED]: "ld:pt-400",
    [SIZES.FIVE_HUNDRED]: "ld:pt-500",
    [SIZES.SIX_HUNDRED]: "ld:pt-600",
    [SIZES.EIGHT_HUNDRED]: "ld:pt-800",
    [SIZES.ONE_THOUSAND]: "ld:pt-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "ld:pt-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "ld:pt-1600"
  },
  [QUERIES.DESKTOP]: {
    [SIZES.NONE]: "de:pt-0",
    [SIZES.FIFTY]: "de:pt-50",
    [SIZES.ONE_HUNDRED]: "de:pt-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "de:pt-150",
    [SIZES.TWO_HUNDRED]: "de:pt-200",
    [SIZES.THREE_HUNDRED]: "de:pt-300",
    [SIZES.FOUR_HUNDRED]: "de:pt-400",
    [SIZES.FIVE_HUNDRED]: "de:pt-500",
    [SIZES.SIX_HUNDRED]: "de:pt-600",
    [SIZES.EIGHT_HUNDRED]: "de:pt-800",
    [SIZES.ONE_THOUSAND]: "de:pt-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "de:pt-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "de:pt-1600"
  },
  [QUERIES.TABLET]: {
    [SIZES.NONE]: "tb:pt-0",
    [SIZES.FIFTY]: "tb:pt-50",
    [SIZES.ONE_HUNDRED]: "tb:pt-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "tb:pt-150",
    [SIZES.TWO_HUNDRED]: "tb:pt-200",
    [SIZES.THREE_HUNDRED]: "tb:pt-300",
    [SIZES.FOUR_HUNDRED]: "tb:pt-400",
    [SIZES.FIVE_HUNDRED]: "tb:pt-500",
    [SIZES.SIX_HUNDRED]: "tb:pt-600",
    [SIZES.EIGHT_HUNDRED]: "tb:pt-800",
    [SIZES.ONE_THOUSAND]: "tb:pt-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "tb:pt-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "tb:pt-1600"
  },
  [QUERIES.LARGEMOBILE]: {
    [SIZES.NONE]: "lm:pt-0",
    [SIZES.FIFTY]: "lm:pt-50",
    [SIZES.ONE_HUNDRED]: "lm:pt-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "lm:pt-150",
    [SIZES.TWO_HUNDRED]: "lm:pt-200",
    [SIZES.THREE_HUNDRED]: "lm:pt-300",
    [SIZES.FOUR_HUNDRED]: "lm:pt-400",
    [SIZES.FIVE_HUNDRED]: "lm:pt-500",
    [SIZES.SIX_HUNDRED]: "lm:pt-600",
    [SIZES.EIGHT_HUNDRED]: "lm:pt-800",
    [SIZES.ONE_THOUSAND]: "lm:pt-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "lm:pt-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "lm:pt-1600"
  },
  [QUERIES.MEDIUMMOBILE]: {
    [SIZES.NONE]: "mm:pt-0",
    [SIZES.FIFTY]: "mm:pt-50",
    [SIZES.ONE_HUNDRED]: "mm:pt-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "mm:pt-150",
    [SIZES.TWO_HUNDRED]: "mm:pt-200",
    [SIZES.THREE_HUNDRED]: "mm:pt-300",
    [SIZES.FOUR_HUNDRED]: "mm:pt-400",
    [SIZES.FIVE_HUNDRED]: "mm:pt-500",
    [SIZES.SIX_HUNDRED]: "mm:pt-600",
    [SIZES.EIGHT_HUNDRED]: "mm:pt-800",
    [SIZES.ONE_THOUSAND]: "mm:pt-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mm:pt-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mm:pt-1600"
  }
};
export const paddingRightClasses = {
  [SIZES.NONE]: "pr-0",
  [SIZES.FIFTY]: "pr-50",
  [SIZES.ONE_HUNDRED]: "pr-100",
  [SIZES.ONE_HUNDRED_FIFTY]: "pr-150",
  [SIZES.TWO_HUNDRED]: "pr-200",
  [SIZES.THREE_HUNDRED]: "pr-300",
  [SIZES.FOUR_HUNDRED]: "pr-400",
  [SIZES.FIVE_HUNDRED]: "pr-500",
  [SIZES.SIX_HUNDRED]: "pr-600",
  [SIZES.EIGHT_HUNDRED]: "pr-800",
  [SIZES.ONE_THOUSAND]: "pr-1000",
  [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "pr-1200",
  [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "pr-1600",
  [QUERIES.LARGEDESKTOP]: {
    [SIZES.NONE]: "ld:pr-0",
    [SIZES.FIFTY]: "ld:pr-50",
    [SIZES.ONE_HUNDRED]: "ld:pr-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "ld:pr-150",
    [SIZES.TWO_HUNDRED]: "ld:pr-200",
    [SIZES.THREE_HUNDRED]: "ld:pr-300",
    [SIZES.FOUR_HUNDRED]: "ld:pr-400",
    [SIZES.FIVE_HUNDRED]: "ld:pr-500",
    [SIZES.SIX_HUNDRED]: "ld:pr-600",
    [SIZES.EIGHT_HUNDRED]: "ld:pr-800",
    [SIZES.ONE_THOUSAND]: "ld:pr-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "ld:pr-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "ld:pr-1600"
  },
  [QUERIES.DESKTOP]: {
    [SIZES.NONE]: "de:pr-0",
    [SIZES.FIFTY]: "de:pr-50",
    [SIZES.ONE_HUNDRED]: "de:pr-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "de:pr-150",
    [SIZES.TWO_HUNDRED]: "de:pr-200",
    [SIZES.THREE_HUNDRED]: "de:pr-300",
    [SIZES.FOUR_HUNDRED]: "de:pr-400",
    [SIZES.FIVE_HUNDRED]: "de:pr-500",
    [SIZES.SIX_HUNDRED]: "de:pr-600",
    [SIZES.EIGHT_HUNDRED]: "de:pr-800",
    [SIZES.ONE_THOUSAND]: "de:pr-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "de:pr-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "de:pr-1600"
  },
  [QUERIES.TABLET]: {
    [SIZES.NONE]: "tb:pr-0",
    [SIZES.FIFTY]: "tb:pr-50",
    [SIZES.ONE_HUNDRED]: "tb:pr-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "tb:pr-150",
    [SIZES.TWO_HUNDRED]: "tb:pr-200",
    [SIZES.THREE_HUNDRED]: "tb:pr-300",
    [SIZES.FOUR_HUNDRED]: "tb:pr-400",
    [SIZES.FIVE_HUNDRED]: "tb:pr-500",
    [SIZES.SIX_HUNDRED]: "tb:pr-600",
    [SIZES.EIGHT_HUNDRED]: "tb:pr-800",
    [SIZES.ONE_THOUSAND]: "tb:pr-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "tb:pr-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "tb:pr-1600"
  },
  [QUERIES.LARGEMOBILE]: {
    [SIZES.NONE]: "lm:pr-0",
    [SIZES.FIFTY]: "lm:pr-50",
    [SIZES.ONE_HUNDRED]: "lm:pr-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "lm:pr-150",
    [SIZES.TWO_HUNDRED]: "lm:pr-200",
    [SIZES.THREE_HUNDRED]: "lm:pr-300",
    [SIZES.FOUR_HUNDRED]: "lm:pr-400",
    [SIZES.FIVE_HUNDRED]: "lm:pr-500",
    [SIZES.SIX_HUNDRED]: "lm:pr-600",
    [SIZES.EIGHT_HUNDRED]: "lm:pr-800",
    [SIZES.ONE_THOUSAND]: "lm:pr-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "lm:pr-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "lm:pr-1600"
  },
  [QUERIES.MEDIUMMOBILE]: {
    [SIZES.NONE]: "mm:pr-0",
    [SIZES.FIFTY]: "mm:pr-50",
    [SIZES.ONE_HUNDRED]: "mm:pr-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "mm:pr-150",
    [SIZES.TWO_HUNDRED]: "mm:pr-200",
    [SIZES.THREE_HUNDRED]: "mm:pr-300",
    [SIZES.FOUR_HUNDRED]: "mm:pr-400",
    [SIZES.FIVE_HUNDRED]: "mm:pr-500",
    [SIZES.SIX_HUNDRED]: "mm:pr-600",
    [SIZES.EIGHT_HUNDRED]: "mm:pr-800",
    [SIZES.ONE_THOUSAND]: "mm:pr-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mm:pr-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mm:pr-1600"
  }
};
export const paddingBottomClasses = {
  [SIZES.NONE]: "pb-0",
  [SIZES.FIFTY]: "pb-50",
  [SIZES.ONE_HUNDRED]: "pb-100",
  [SIZES.ONE_HUNDRED_FIFTY]: "pb-150",
  [SIZES.TWO_HUNDRED]: "pb-200",
  [SIZES.THREE_HUNDRED]: "pb-300",
  [SIZES.FOUR_HUNDRED]: "pb-400",
  [SIZES.FIVE_HUNDRED]: "pb-500",
  [SIZES.SIX_HUNDRED]: "pb-600",
  [SIZES.EIGHT_HUNDRED]: "pb-800",
  [SIZES.ONE_THOUSAND]: "pb-1000",
  [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "pb-1200",
  [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "pb-1600",
  [QUERIES.LARGEDESKTOP]: {
    [SIZES.NONE]: "ld:pb-0",
    [SIZES.FIFTY]: "ld:pb-50",
    [SIZES.ONE_HUNDRED]: "ld:pb-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "ld:pb-150",
    [SIZES.TWO_HUNDRED]: "ld:pb-200",
    [SIZES.THREE_HUNDRED]: "ld:pb-300",
    [SIZES.FOUR_HUNDRED]: "ld:pb-400",
    [SIZES.FIVE_HUNDRED]: "ld:pb-500",
    [SIZES.SIX_HUNDRED]: "ld:pb-600",
    [SIZES.EIGHT_HUNDRED]: "ld:pb-800",
    [SIZES.ONE_THOUSAND]: "ld:pb-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "ld:pb-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "ld:pb-1600"
  },
  [QUERIES.DESKTOP]: {
    [SIZES.NONE]: "de:pb-0",
    [SIZES.FIFTY]: "de:pb-50",
    [SIZES.ONE_HUNDRED]: "de:pb-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "de:pb-150",
    [SIZES.TWO_HUNDRED]: "de:pb-200",
    [SIZES.THREE_HUNDRED]: "de:pb-300",
    [SIZES.FOUR_HUNDRED]: "de:pb-400",
    [SIZES.FIVE_HUNDRED]: "de:pb-500",
    [SIZES.SIX_HUNDRED]: "de:pb-600",
    [SIZES.EIGHT_HUNDRED]: "de:pb-800",
    [SIZES.ONE_THOUSAND]: "de:pb-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "de:pb-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "de:pb-1600"
  },
  [QUERIES.TABLET]: {
    [SIZES.NONE]: "tb:pb-0",
    [SIZES.FIFTY]: "tb:pb-50",
    [SIZES.ONE_HUNDRED]: "tb:pb-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "tb:pb-150",
    [SIZES.TWO_HUNDRED]: "tb:pb-200",
    [SIZES.THREE_HUNDRED]: "tb:pb-300",
    [SIZES.FOUR_HUNDRED]: "tb:pb-400",
    [SIZES.FIVE_HUNDRED]: "tb:pb-500",
    [SIZES.SIX_HUNDRED]: "tb:pb-600",
    [SIZES.EIGHT_HUNDRED]: "tb:pb-800",
    [SIZES.ONE_THOUSAND]: "tb:pb-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "tb:pb-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "tb:pb-1600"
  },
  [QUERIES.LARGEMOBILE]: {
    [SIZES.NONE]: "lm:pb-0",
    [SIZES.FIFTY]: "lm:pb-50",
    [SIZES.ONE_HUNDRED]: "lm:pb-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "lm:pb-150",
    [SIZES.TWO_HUNDRED]: "lm:pb-200",
    [SIZES.THREE_HUNDRED]: "lm:pb-300",
    [SIZES.FOUR_HUNDRED]: "lm:pb-400",
    [SIZES.FIVE_HUNDRED]: "lm:pb-500",
    [SIZES.SIX_HUNDRED]: "lm:pb-600",
    [SIZES.EIGHT_HUNDRED]: "lm:pb-800",
    [SIZES.ONE_THOUSAND]: "lm:pb-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "lm:pb-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "lm:pb-1600"
  },
  [QUERIES.MEDIUMMOBILE]: {
    [SIZES.NONE]: "mm:pb-0",
    [SIZES.FIFTY]: "mm:pb-50",
    [SIZES.ONE_HUNDRED]: "mm:pb-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "mm:pb-150",
    [SIZES.TWO_HUNDRED]: "mm:pb-200",
    [SIZES.THREE_HUNDRED]: "mm:pb-300",
    [SIZES.FOUR_HUNDRED]: "mm:pb-400",
    [SIZES.FIVE_HUNDRED]: "mm:pb-500",
    [SIZES.SIX_HUNDRED]: "mm:pb-600",
    [SIZES.EIGHT_HUNDRED]: "mm:pb-800",
    [SIZES.ONE_THOUSAND]: "mm:pb-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mm:pb-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mm:pb-1600"
  }
};
export const paddingLeftClasses = {
  [SIZES.NONE]: "pl-0",
  [SIZES.FIFTY]: "pl-50",
  [SIZES.ONE_HUNDRED]: "pl-100",
  [SIZES.ONE_HUNDRED_FIFTY]: "pl-150",
  [SIZES.TWO_HUNDRED]: "pl-200",
  [SIZES.THREE_HUNDRED]: "pl-300",
  [SIZES.FOUR_HUNDRED]: "pl-400",
  [SIZES.FIVE_HUNDRED]: "pl-500",
  [SIZES.SIX_HUNDRED]: "pl-600",
  [SIZES.EIGHT_HUNDRED]: "pl-800",
  [SIZES.ONE_THOUSAND]: "pl-1000",
  [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "pl-1200",
  [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "pl-1600",
  [QUERIES.LARGEDESKTOP]: {
    [SIZES.NONE]: "ld:pl-0",
    [SIZES.FIFTY]: "ld:pl-50",
    [SIZES.ONE_HUNDRED]: "ld:pl-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "ld:pl-150",
    [SIZES.TWO_HUNDRED]: "ld:pl-200",
    [SIZES.THREE_HUNDRED]: "ld:pl-300",
    [SIZES.FOUR_HUNDRED]: "ld:pl-400",
    [SIZES.FIVE_HUNDRED]: "ld:pl-500",
    [SIZES.SIX_HUNDRED]: "ld:pl-600",
    [SIZES.EIGHT_HUNDRED]: "ld:pl-800",
    [SIZES.ONE_THOUSAND]: "ld:pl-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "ld:pl-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "ld:pl-1600"
  },
  [QUERIES.DESKTOP]: {
    [SIZES.NONE]: "de:pl-0",
    [SIZES.FIFTY]: "de:pl-50",
    [SIZES.ONE_HUNDRED]: "de:pl-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "de:pl-150",
    [SIZES.TWO_HUNDRED]: "de:pl-200",
    [SIZES.THREE_HUNDRED]: "de:pl-300",
    [SIZES.FOUR_HUNDRED]: "de:pl-400",
    [SIZES.FIVE_HUNDRED]: "de:pl-500",
    [SIZES.SIX_HUNDRED]: "de:pl-600",
    [SIZES.EIGHT_HUNDRED]: "de:pl-800",
    [SIZES.ONE_THOUSAND]: "de:pl-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "de:pl-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "de:pl-1600"
  },
  [QUERIES.TABLET]: {
    [SIZES.NONE]: "tb:pl-0",
    [SIZES.FIFTY]: "tb:pl-50",
    [SIZES.ONE_HUNDRED]: "tb:pl-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "tb:pl-150",
    [SIZES.TWO_HUNDRED]: "tb:pl-200",
    [SIZES.THREE_HUNDRED]: "tb:pl-300",
    [SIZES.FOUR_HUNDRED]: "tb:pl-400",
    [SIZES.FIVE_HUNDRED]: "tb:pl-500",
    [SIZES.SIX_HUNDRED]: "tb:pl-600",
    [SIZES.EIGHT_HUNDRED]: "tb:pl-800",
    [SIZES.ONE_THOUSAND]: "tb:pl-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "tb:pl-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "tb:pl-1600"
  },
  [QUERIES.LARGEMOBILE]: {
    [SIZES.NONE]: "lm:pl-0",
    [SIZES.FIFTY]: "lm:pl-50",
    [SIZES.ONE_HUNDRED]: "lm:pl-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "lm:pl-150",
    [SIZES.TWO_HUNDRED]: "lm:pl-200",
    [SIZES.THREE_HUNDRED]: "lm:pl-300",
    [SIZES.FOUR_HUNDRED]: "lm:pl-400",
    [SIZES.FIVE_HUNDRED]: "lm:pl-500",
    [SIZES.SIX_HUNDRED]: "lm:pl-600",
    [SIZES.EIGHT_HUNDRED]: "lm:pl-800",
    [SIZES.ONE_THOUSAND]: "lm:pl-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "lm:pl-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "lm:pl-1600"
  },
  [QUERIES.MEDIUMMOBILE]: {
    [SIZES.NONE]: "mm:pl-0",
    [SIZES.FIFTY]: "mm:pl-50",
    [SIZES.ONE_HUNDRED]: "mm:pl-100",
    [SIZES.ONE_HUNDRED_FIFTY]: "mm:pl-150",
    [SIZES.TWO_HUNDRED]: "mm:pl-200",
    [SIZES.THREE_HUNDRED]: "mm:pl-300",
    [SIZES.FOUR_HUNDRED]: "mm:pl-400",
    [SIZES.FIVE_HUNDRED]: "mm:pl-500",
    [SIZES.SIX_HUNDRED]: "mm:pl-600",
    [SIZES.EIGHT_HUNDRED]: "mm:pl-800",
    [SIZES.ONE_THOUSAND]: "mm:pl-1000",
    [SIZES.ONE_THOUSAND_TWO_HUNDRED]: "mm:pl-1200",
    [SIZES.ONE_THOUSAND_SIX_HUNDRED]: "mm:pl-1600"
  }
};